import React from 'react'
//@ts-ignore
import Tippy from '@tippyjs/react';
import { ReferenceComponent } from '../inlineReference';
import { handleDelete } from '../../../../utils/actions';
import { pushRouteFromEditor, type EditorRouteData } from '../utils/pushRouteFromEditor';


export const BlockReference = function ({ entry, editor, element, ...props }) {
  const { history, apiKey } = editor?.requestProps || {};
  const currentBranch = editor?.requestProps?.branch
  const contentTypeUid = element?.attrs?.['content-type-uid'],
    entryUid = element?.attrs?.['entry-uid'],
    locale = element?.attrs?.['locale'];

  const handleEdit = () => {
    if (editor?.referenceActions?.editBlockReference) {
      editor.referenceActions.editBlockReference({ contentTypeUid, entryUid, locale })
      return;
    }

    const pathname = `/stack/${apiKey}/content-type/${contentTypeUid}/${locale}/entry/${entryUid}/edit`
    const search = currentBranch ? `branch=${currentBranch}` : ''
    const state = editor.isDraft ? editor.getReferredObj({ ctUid: contentTypeUid, blockUid: element.uid, pathname, search }) : {}

    const newHistoryData: EditorRouteData = {
        pathname,
        search,
        ...(editor.isDraft ? { state } : {}),
      }

      pushRouteFromEditor(editor, newHistoryData)
  }

  const handleOpenInModal = editor?.isEntryInModalEnabled
    ? () => editor?.openEmbeddedEntryInModal?.({ entryUid, contentTypeUid, locale })
    : undefined

  const contentTypeNameMap = editor.contentTypeNameMap || {}
  const contentTypeName = contentTypeNameMap[contentTypeUid] || contentTypeUid
  return (
    <Tippy placement='bottom' content={entry['error'] && <span className="tippy-box-dark tippy-box"
      style={{ padding: '.25rem .3rem', fontFamily: 'Inter' }} data-testid={'block-reference-error'}>{entry['error']}</span>}
    >
      <ReferenceComponent editor={editor} type='block' handleEdit={handleEdit} handleOpenInModal={handleOpenInModal} handleDelete={(e) => handleDelete(editor, element)} entry={entry} content_type_uid={contentTypeName} attributes={{ ...props.attributes, ...props.attrs, element }} children={props.children} />
    </Tippy>
  )
}

export * from './deserializer';